import { Box, Grid, Text, keyframes } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { useKanguCargobr } from '../../../../../contexts/KanguCargobrContext'
import { CardTransp } from './CardTransp'

export function Transportadora({
  shipping,
  setFrete,
  shippingKangu,
  handleParams,
  shippingBuslog,
  shippingFedex,
  isSp,
  numeroNota,
  quantidadeCaixas,
  isCapital,
  itemCotado,
  handleKangu,
  isFreteGratis,
  transpCode,
}) {
  const [selected, setSelected] = useState([])
  const { cubagens, isFreeShipping } = useKanguCargobr()
  const [allShipping, setAllShipping] = useState([])
  const [transportadoraGratis, setTransportadoraGratis] = useState(null)
  const [isKangu, setIsKangu] = useState(false)
  const [transp10PorCentoAMaisDaGratis, setTransp10PorCentoAMaisDaGratis] = useState(null)

  useEffect(() => {
    const isKangu = handleKangu()

    setIsKangu(isKangu)
  }, [cubagens])

  const valorTotalItems = cubagens?.reduce((acc, curr) => {
    const { vlr_total } = curr
    return parseFloat(acc) + parseFloat(vlr_total)
  }, 0)

  function selectRow(item) {
    setSelected(item)
    const valorFrete = item.nome === 'Nosso Carro' ? item.preco : item.preco * 1.3

    setFrete(valorFrete)

    handleParams(item)
  }

  const isMotoEntrega = isSp && isKangu

  const nossoCarro = [
    {
      nome: 'Nosso Carro',
      nome_transp: 'Nosso Carro',
      tipo_transportadora: 'N',
      isIntern: true,
      quantidade_caixas: quantidadeCaixas,
      numero_nota: numeroNota,
      id: '129030vmmvmm293',
      prazo: {
        min: 1,
        max: 1,
      },
      preco: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
      valor_simulacao: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
      precoReal: 0,
    },
  ]

  const transportadoraCliente = [
    {
      nome: 'Transportadora Cliente',
      nome_transp: 'Transportadora Cliente',
      id: '129030vmmvmm29323',
      numero_nota: numeroNota,
      isIntern: true,
      prazo: {
        min: 1,
        max: 1,
      },
      preco: 0,
      precoReal: 0,
      tipo_transportadora: 'TC',
      valor_simulacao: 0,
      cod_transp: transpCode,
      quantidade_caixas: quantidadeCaixas,
    },
  ]

  const clienteRetira = [
    {
      nome: 'Cliente Retira',
      nome_transp: 'Cliente Retira',
      numero_nota: numeroNota,
      quantidade_caixas: quantidadeCaixas,
      id: '23ccc223fbbbssxx',
      tipo_transportadora: 'C',
      isIntern: true,
      prazo: {
        min: 1,
        max: 1,
      },
      preco: 0,
      precoReal: 0,
      valor_simulacao: 0,
    },
  ]

  useEffect(() => {
    const buslogIsValid = shippingBuslog !== undefined && shippingBuslog.length !== 0 ? shippingBuslog : []
    const shippingIsValid = shipping !== undefined && shipping.length !== 0 ? shipping : []
    const shippingFedexIsValid = shippingFedex !== undefined && shippingFedex.length !== 0 ? shippingFedex : []

    if (isSp) {
      const array = [
        ...clienteRetira,
        ...nossoCarro,
        ...buslogIsValid.filter((item) => !item.isMelhorEnvio), // Filtra para não incluir o Melhor Envio
        ...shippingIsValid,
        ...shippingFedexIsValid,
        ...transportadoraCliente,
      ]

      //ordenar o array por preco
      const arrayOrdenado = array.sort((a, b) => a.preco - b.preco).filter((item) => item !== undefined)

      //setar o array ordenado no estado de shipping
      setAllShipping(arrayOrdenado)
    } else {
      const array = [
        ...clienteRetira,
        ...buslogIsValid.filter((item) => !item.isMelhorEnvio), // Filtra para não incluir o Melhor Envio
        ...shippingIsValid,
        ...shippingFedexIsValid,
        ...transportadoraCliente,
      ]

      //ordenar o array por preco
      const arrayOrdenado = array.sort((a, b) => a.preco - b.preco).filter((item) => item !== undefined)

      //setar o array ordenado no estado de shipping
      setAllShipping(arrayOrdenado)
    }
  }, [cubagens, transpCode])

  useEffect(() => {
    const totalTransp = []

    const kanguTransp = []

    if (shippingKangu?.length > 0) {
      for (const item of shippingKangu) {
        const { nome, preco, prazo, tipo_transportadora } = item

        const desestrucKangu = {
          ...item,
          id: 'aplsdfmpsaodinfpasn',
          nome,
          preco,
          prazo: {
            min: prazo.min,
            max: prazo.max,
          },
          tipo_transportadora,
        }

        totalTransp.push(desestrucKangu)
      }
    }

    totalTransp.push(...allShipping, kanguTransp)

    const transportadoraSemGratis = totalTransp.filter(
      (transportadora) =>
        transportadora.nome !== 'Nosso Carro' && transportadora.nome !== 'Cliente Retira' && transportadora.nome !== 'Transportadora Cliente'
    )

    const motoEntregaMaisBarata = totalTransp.reduce((prev, current) => {
      return prev.originalValue <= 25 ? prev : current
    })

    const isKangu = handleKangu()

    if (isMotoEntrega && isKangu) {
      const motoEntrega = {
        nome: 'Frete Gratis',
        original_name: 'Moto frete gratis',
        numero_nota: numeroNota,
        tipo_transportadora: 'MT',
        preco: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
        valor_simulacao: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
        isFreeSp: true,
        isGratis: true,
        flag: 'Moto',
        isIntern: true,
        prazo: {
          max: 2,
        },
      }

      setTransportadoraGratis(motoEntrega)
      return
    }

    if (isSp && !isKangu) {
      const nossoCarro = {
        nome: 'Frete Gratis',
        original_name: 'Nosso Carro',
        isGratis: true,
        preco: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
        valor_simulacao: isCapital ? (valorTotalItems >= 2000 ? 0 : 80) : 140,
        isFreeSp: true,
        numero_nota: numeroNota,
        flag: 'Carro',
        prazo: {
          max: 2,
        },
        tipo_transportadora: 'N',
        isIntern: true,
      }

      setTransportadoraGratis(nossoCarro)
      return
    }

    const transpMaisBarata = transportadoraSemGratis.reduce((menor, atual) => {
      if (atual.preco && atual.preco < menor.preco) {
        return atual
      }
      return menor
    })

    if (cubagens.length > 0) {
      const transpGratis = {
        ...transpMaisBarata,
        id: new Date().getTime().toString(),
        preco: 0,
        realprice: transpMaisBarata?.preco,
        nome: 'Frete Gratis',
        prazo: {
          max: transpMaisBarata?.prazo?.max,
        },
        isTransportadora: true,
      }
      setTransportadoraGratis(transpGratis)
    }
  }, [allShipping, cubagens, isFreeShipping])

  console.log('transportadoraGratis', transportadoraGratis)

  const shippingNotTnt = allShipping.filter((item) => item.nome !== 'TNT')

  const verifyFreteGratis = isMotoEntrega ? shippingNotTnt : allShipping

  const verifyIsMotoEntrega = isFreteGratis ? verifyFreteGratis.filter((item) => item.nome !== 'Nosso Carro') : verifyFreteGratis

  const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

  function verifyTransp10PorCentoAMaisDaGratis() {
    if (!transportadoraGratis) return

    const kanguMaisAllShipping = []

    if (shippingKangu?.length > 0) {
      kanguMaisAllShipping.push(...shippingKangu, ...allShipping)
    } else {
      kanguMaisAllShipping.push(...allShipping)
    }

    let tranps10PorCentoAMaisDaGratis = []

    const { originalValue, prazo } = transportadoraGratis
    const prazoMax = prazo.max

    const preco10PorCentoAMais = originalValue + originalValue * 0.1

    const transportadorasCom10PorcentoDeAcrescimo = kanguMaisAllShipping.map((item) => {
      if (item.nome !== 'Nosso Carro' && item.nome !== 'Cliente Retira') {
        return {
          ...item,
          isGratis: item.originalValue <= preco10PorCentoAMais && isFreteGratis,
        }
      }
      return item
    })

    tranps10PorCentoAMaisDaGratis = transportadorasCom10PorcentoDeAcrescimo.filter(
      (item) => item.nome !== 'Nosso Carro' && item.nome !== 'Cliente Retira' && item.nome !== 'Transportadora Cliente'
    )

    setTransp10PorCentoAMaisDaGratis(tranps10PorCentoAMaisDaGratis)
  }

  const replaceTntNossoCarroAndClienteRetira = transp10PorCentoAMaisDaGratis?.filter(
    (item) => item.nome !== 'Nosso Carro' && item.nome !== 'Cliente Retira' && item.nome !== 'Transportadora Cliente' && item.nome !== 'J3 - Tracken'
  )

  useEffect(() => {
    verifyTransp10PorCentoAMaisDaGratis()
  }, [transportadoraGratis, cubagens])

  return (
    <Grid templateColumns="repeat(2, 1fr)" mt="1rem" gap={'4rem'}>
      <Box>
        <Grid templateColumns={'2fr 1fr 1fr 1fr'} bgColor="#e9e9e9" paddingBlock=".8rem">
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="start" paddingLeft="1rem">
            Transportadora
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Prazo
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Valor real
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Valor + 30%
          </Text>
        </Grid>
        <Box display={itemCotado ? 'block' : 'none'}>
          {isFreteGratis && cubagens.length > 0 && transportadoraGratis !== null && !transportadoraGratis.isTransportadora && (
            <CardTransp item={transportadoraGratis} index={0} selected={selected} selectRow={selectRow} />
          )}
        </Box>

        {cubagens &&
          !isMotoEntrega &&
          replaceTntNossoCarroAndClienteRetira?.map((item, index) => (
            <Box display={itemCotado ? 'block' : 'none'} key={index} animation={`${fadeIn} 0.3s ease-in-out`}>
              <CardTransp item={item} index={index} selected={selected} selectRow={selectRow} isGratis={item.isGratis} />
            </Box>
          ))}
      </Box>
      <Box>
        <Grid templateColumns={'2fr 1fr 1fr 1fr'} bgColor="#e9e9e9" paddingBlock=".8rem">
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="start" paddingLeft="1rem">
            Transportadora
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Prazo
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Valor real
          </Text>
          <Text as="h1" m="0" fontSize="1rem" fontWeight="bold" textAlign="center">
            Valor + 30%
          </Text>
        </Grid>
        <Box display={itemCotado ? 'block' : 'none'} animation={`${fadeIn} 0.3s ease-in-out`}>
          {cubagens?.length !== 0 &&
            verifyIsMotoEntrega
              ?.filter((item) => item.nome !== 'TNT')
              .map((item) => <CardTransp item={item} selected={selected} selectRow={selectRow} />)}
        </Box>
      </Box>
    </Grid>
  )
}
